import { render, staticRenderFns } from "./mdc-icon.vue?vue&type=template&id=22e16972&"
import script from "./mdc-icon.vue?vue&type=script&lang=ts&"
export * from "./mdc-icon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports